import { useState } from 'react';
import { motion } from 'framer-motion';
import clsx from 'clsx';
import { PLACEHOLDER_PRODUCT_IMAGE } from '../../lib/constants';

/**
 * Image component with blur placeholder and lazy loading.
 */
export function ImageWithPlaceholder({
  src,
  alt,
  className = '',
  aspectRatio = 'aspect-[4/3]',
}) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  const imgSrc = error || !src ? PLACEHOLDER_PRODUCT_IMAGE : src;

  return (
    <div className={clsx('relative overflow-hidden bg-brand-light', aspectRatio, className)}>
      {/* Blur placeholder */}
      {!loaded && (
        <div className="absolute inset-0 bg-brand-light animate-pulse" />
      )}
      <motion.img
        src={imgSrc}
        alt={alt}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        onError={() => setError(true)}
        initial={{ opacity: 0 }}
        animate={{ opacity: loaded ? 1 : 0 }}
        transition={{ duration: 0.4 }}
        className="absolute inset-0 w-full h-full object-cover"
      />
    </div>
  );
}
